import React, { FC } from 'react';

import { Grid, Hidden } from '@material-ui/core';

import { TeeAssignationRowStyled } from './TeeAssignationRow/TeeAssignationRow.Styles';

const TeeBoxRowsTitle: FC = () => {
  return (
    <Hidden smDown={true}>
      <TeeAssignationRowStyled container={true} spacing={2} className="table-title">
        <Grid item={true} xs={2} className="table-title-sex" alignItems="flex-start">
          Sex
        </Grid>

        <Grid item={true} xs={2} className="table-title-range">
          Age range
        </Grid>

        <Grid item={true} xs={2} className="table-title-range">
          Index range
        </Grid>

        <Grid item={true} xs={5}>
          <Grid container={true} spacing={0}>
            <Grid className="grid-item table-title-range" item={true} xs={5}>
              <span className="tee-markers">TEE MARKER</span>
            </Grid>

            <Grid className="grid-item table-title-range" item={true} xs={2}>
              <span className="grey-square">PAR</span>
            </Grid>

            <Grid className="grid-item table-title-range" item={true} xs={2}>
              <span className="grey-square">SLOPE</span>
            </Grid>

            <Grid className="grid-item table-title-range" item={true} xs={2}>
              <span className="grey-square">RATING</span>
            </Grid>

            <Grid className="grid-item table-title-range" item={true} xs={1} />
          </Grid>
        </Grid>

        <Grid item={true} xs={1} />
      </TeeAssignationRowStyled>
    </Hidden>
  );
};

export default TeeBoxRowsTitle;
